import React from 'react';
import SupportHeader from '../../components/Header/SupportHeader';
import { Footer } from '../../components';
import { useHistory } from 'react-router-dom';
import './404.css';
import CustomButton from '../../components/MasterComponent/Button/CustomButton';
import { RoutesFun } from '../../schemas';

export const Error403: React.FC = () => {
  const history = useHistory();
  return (
    <div className="outerContainer ">
      <SupportHeader />
      <div className="container-404 py-35 my-35">
        <div className="item-404">403</div>
        <div className="error-text p-10">
          You don't have permission to access this page!
        </div>
        {/* <Link className="home-link m-30" to={{ pathname: '/' }}>
          Go to Home
        </Link> */}
        <CustomButton
          buttonType="outlined"
          onClickHandler={() => history.push(RoutesFun().Home)}
          style={{ fontSize: '18px', marginTop: '2rem' }}
        >
          Go to home
        </CustomButton>
      </div>

      <Footer />
    </div>
  );
};

export default Error403;
